











































import { Component, PropSync, Vue } from 'vue-property-decorator';

@Component({ name: 'PubliclyTradedCompanies' })
export default class PubliclyTradedCompanies extends Vue {
  @PropSync('isOpen', { type: Boolean })
  synced_is_open!: boolean;
}
